import { apartmentModelGet } from '../../models/apartments/apartment';
import { receiptViewModelModelGet } from '../receipts/receiptViewModel';

const decimal = 0.00;

export const apartmentReceiptViewModelModelGet = ({ buildingId = '', floor = 0, apartmentId = '', receiptId = '', userId = '', }) => {
    return {
        ...apartmentModelGet({
            buildingId: buildingId,
            floor: floor,
            userId: userId,
        }),
        balance: decimal,
        receipts: [
            receiptViewModelModelGet({
                buildingId: buildingId,
                apartmentId: apartmentId,
                receiptId: receiptId,
                userId: userId,
            }),
        ],
        process: {
            edit: false,
            details: false,
            delete: false,
        }
    }
}